export const VIEW_MODE_PARSED = {id: 'parsed', title: 'document-inspector.view-mode.parsed'}
export const VIEW_MODE_RAW = {id: 'raw', title: 'document-inspector.view-mode.raw-json'}
export const VIEW_MODES = [VIEW_MODE_PARSED, VIEW_MODE_RAW]
